// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__3HPDr","modal":"Modal_modal__NuGGC","navItem":"Modal_navItem__pLSaz","navItem_link":"Modal_navItem_link__asdqO","active":"Modal_active__YqUdw"};